import type { PropsWithChildren } from "react";

type RouteViewConfig = Partial<{
    wrapper: React.ComponentType<PropsWithChildren>;
}>;

export const routeViewConfig: RouteViewConfig = {};

export function setRouteViewWrapper(wrapper: React.ComponentType<PropsWithChildren>) {
    routeViewConfig.wrapper = wrapper;
}
